'use client';

import SectionTitle from '@/components/section-title/section-title';
import { useTranslations } from 'next-intl';

type CoursesSectionTitleProps = {
  isVashaAcademy: boolean;
};

export default function CoursesSectionTitle({
  isVashaAcademy,
}: CoursesSectionTitleProps) {
  const t = useTranslations();

  return (
    <SectionTitle align="center">
      {isVashaAcademy ? t('vasha-academy-home-page.courses') : 'কোর্সসমূহ'}
    </SectionTitle>
  );
}
